__turbopack_context__.v({
  "breadcrumb": "WammuG_breadcrumb",
  "breadcrumb__current": "WammuG_breadcrumb__current",
  "breadcrumb__expand": "WammuG_breadcrumb__expand",
  "breadcrumb__item": "WammuG_breadcrumb__item",
  "breadcrumb__item--collapsed": "WammuG_breadcrumb__item--collapsed",
  "breadcrumb__items": "WammuG_breadcrumb__items",
  "breadcrumb__link": "WammuG_breadcrumb__link",
  "breadcrumb__toggle": "WammuG_breadcrumb__toggle",
});
